import "./sidebar.scss";
import React, { useContext } from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import QueryBuilder from '@mui/icons-material/QueryBuilder';
import RouteIcon from '@mui/icons-material/Route';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png"
import logoCollapsed from "../../assets/images/logoCollapsed.png"
import { useSidebarState } from './SidebarStateContext';
import { AuthContext } from '../../store/AuthContext';
import { getUserScope } from '../../shared/utils/roleScope';
import { puedeAccederColaboracion } from '../../pages/equiposColaborativos/colaboracionAccess';
import { usePendientesSidebar } from './usePendientesSidebar';

// Burbuja azul con el número de pendientes; se oculta si no hay ninguna.
const Badge = ({ count }) => {
  if (!count) return null;
  return <span className="pendientes-badge">{count > 99 ? '99+' : count}</span>;
};

/**
 * Componente de la barra lateral de navegación.
 */
const Sidebar = () => {
  const { collapsed } = useSidebarState();
  const { currentUser, adminData } = useContext(AuthContext);
  // Colaboración en Equipos (Kit Digital): lo ven los 3 usuarios del allowlist
  // (participan en la colaboración) Y también cualquier administrador (acceso
  // total de gestión, aunque no aparezca como miembro de equipo).
  const puedeVerColaboracionEquipos =
    puedeAccederColaboracion(currentUser?.email) || getUserScope(adminData).isAll;
  const pendientes = usePendientesSidebar();

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="top">

        <Link to="/" style={{ textDecoration: "none" }}>
          {!collapsed && (
            <span className="logo">
              <img src={logo} alt="logo" />
              SENTRY
            </span>
          )}
          {collapsed && (
            <span className="logoCollapsed">
              <img src={logoCollapsed} alt="logo" />
            </span>
          )}
        </Link>
      </div>

      <hr />
      <div className="center">
        <ul>
          <Link to="/documentos" style={{ textDecoration: "none" }}>
            <li>
              <DescriptionOutlinedIcon className="icon" />
              <span className="link-text">Documentos</span>
            </li>
          </Link>
          <Link to="/" style={{ textDecoration: "none" }}>
            <li>
              <DashboardOutlinedIcon className="icon" />
              <span className="link-text">Dashboard</span>
            </li>
          </Link>
          <Link to="/cuadrantes" style={{ textDecoration: "none" }}>
            <li>
              <CalendarMonthIcon className="icon" />
              <span className="link-text">Cuadrantes</span>
            </li>
          </Link>

          <Link to="/vigilantes" style={{ textDecoration: "none" }}>
            <li>
              <BadgeOutlinedIcon className="icon" />
              <span className="link-text">Usuarios</span>
            </li>
          </Link>
          <Link to="/clientes" style={{ textDecoration: "none" }}>
            <li>
              <GroupsOutlinedIcon className="icon" />
              <span className="link-text">Clientes</span>
            </li>
          </Link>
          <Link to="/jornadas" style={{ textDecoration: "none" }}>
            <li>
              <QueryBuilder className="icon" />
              <span className="link-text">Control Horario</span>
            </li>
          </Link>
          <Link to="/control-rondas" style={{ textDecoration: "none" }}>
            <li>
              <RouteIcon className="icon" />
              <span className="link-text">Control de Rondas</span>
            </li>
          </Link>
          <Link to="/cambios-turno" style={{ textDecoration: "none" }}>
            <li>
              <SwapHorizIcon className="icon" />
              <span className="link-text">Cambios de Turno</span>
              <Badge count={pendientes.cambiosTurno} />
            </li>
          </Link>
          <Link to="/solicitudes" style={{ textDecoration: "none" }}>
            <li>
              <AssignmentOutlinedIcon className="icon" />
              <span className="link-text">Solicitudes</span>
              <Badge count={pendientes.solicitudes} />
            </li>
          </Link>
          <Link to="/form-table" style={{ textDecoration: "none" }}>
            <li>
              <FileOpenOutlinedIcon className="icon" />
              <span className="link-text">Formularios</span>
            </li>
          </Link>
          <Link to="/pdf-designs" style={{ textDecoration: "none" }}>
            <li>
              <PictureAsPdfIcon className="icon" />
              <span className="link-text">Diseño PDF</span>
            </li>
          </Link>
          <Link to="/notificaciones" style={{ textDecoration: "none" }}>
            <li>
              <NotificationsActiveIcon className="icon" />
              <span className="link-text">Notificaciones</span>
            </li>
          </Link>
          {puedeVerColaboracionEquipos && (
            <Link to="/colaboracion-equipos" style={{ textDecoration: "none" }}>
              <li>
                <Diversity3Icon className="icon" />
                <span className="link-text">Colaboración en Equipos</span>
              </li>
            </Link>
          )}
          {/* <Link to="/datasets" style={{ textDecoration: "none" }}>
            <li>
              <span className="icon">🧪</span>
              <span className="link-text">Datasets</span>
            </li>
          </Link> */}
        </ul>
      </div>
      <div className="bottom">
        <div className="privacy-policy-link">
          <Link to="/privacy-policy">Política de Privacidad</Link>
        </div>
        <div className="privacy-policy-link">
          <a href="https://bepart-innova.gitbook.io/sentry/" alt="guías">Guías de usuario</a>
        </div>
        <div className="privacy-policy-link">
          <Link to="/accesos">Accesos Usuarios</Link>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;